<label class="soft-ds-date-range-input-root">
  <div class="soft-ds-date-range-input-field">
    <input
      class="soft-ds-date-range-input-control"
      [id]="inputId() || null"
      [value]="textInput() ?? (value() | format: format())"
      (input)="onTextInput(inputElement.value)"
      (change)="onValueChange(inputElement.value)"
      #inputElement
      (pointerdown)="onInputPointerDown()"
      (focus)="onInputFocus()"
      (click)="onInputClick()"
      (dblclick)="canOpenPicker() ? openDateRangePickerModal() : null"
      (blur)="onInputBlur()"
      [readOnly]="readonly() || disabled()"
      [attr.aria-readonly]="readonly() || null"
      [attr.aria-disabled]="disabled() || null"
      [placeholder]="placeholder() | translate"
    />
    @if (canOpenPicker()) {
      <button
        type="button"
        class="soft-ds-date-range-input-trigger"
        aria-label="Open date range picker"
        (click)="onTriggerClick()"
      >
        <soft-ds-icon name="fa-regular fa-calendar-range" />
      </button>
    }
    @if (disabled()) {
      <soft-ds-icon class="soft-ds-date-range-input-state-icon" name="fa-regular fa-ban" />
    }
    @if (readonly()) {
      <soft-ds-icon class="soft-ds-date-range-input-state-icon" name="fa-regular fa-lock" />
    }
  </div>
</label>
